<template>
  <div
    :id="id"
    class="d-flex align-items-center toggle-switch"
  >
    <span
      v-if="negativeLabel !== ''"
      :class="negativeLabelClass"
    >
      {{$t(negativeLabel)}}
    </span>
    <span
      class="Fuell-Toggle-switch mr-2"
      :class="switchStatusClass"
      @click="changeStatus"
    >
      <span
        class="Fuell-Toggle-switch--sphere"
        :class="toggleStatusClass"
      ></span>
    </span>
    <span
      v-if="!useLabelSlot"
      :class="labelClass"
    >{{$t(label)}}
      <info-display
        v-if="showInfo"
        :class="'icon-info'"
        :infoText="infoText"
      />
    </span>
    <slot
      name="label"
      v-else
    ></slot>
  </div>

</template>

<script>
import InfoDisplay from '@/components/Commons/InfoDisplay'
export default {
  name: 'ToggleSwitch',
  components: {
    InfoDisplay
  },
  props: {
    id: {
      type: String
    },
    status: {
      type: Boolean,
      required: true
    },
    showInfo: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    },
    infoText: {
      type: String
    },
    labelClass: {
      type: String,
      default: ''
    },
    switchClass: {
      type: String,
      default: ''
    },
    sphereClass: {
      type: String,
      default: ''
    },
    negativeLabel: {
      type: String,
      default: ''
    },
    negativeLabelClass: {
      type: String,
      default: ''
    },
    updateOnChange: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    useLabelSlot: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    changeStatus () {
      this.statusValue = !this.status
    }
  },

  computed: {
    statusValue: {
      get () {
        return this.status
      },
      set (v) {
        if (this.disabled) return
        if (this.updateOnChange) {
          this.$emit('change', v)
        } else {
          this.$emit('update:status', v)
          this.$emit('change', v)
        }
      }

    },
    switchStatusClass () {
      let className = ''
      if (this.switchClass === '') {
        className = this.status ? 'Fuell-Toggle-switch--enabled' : 'Fuell-Toggle-switch--inactive'
      } else {
        className = this.switchClass
      }
      return this.disabled ? `${className} Fuell-Toggle-switch--disabled` : className
    },
    toggleStatusClass () {
      let className = ''
      if (this.sphereClass === '') {
        className = this.status ? 'Fuell-Toggle-switch--sphere--enabled' : 'Fuell-Toggle-switch--sphere--inactive'
      } else {
        className = this.sphereClass
      }
      return this.disabled ? `${className} Fuell-Toggle-switch--sphere--disabled` : className
    }
  }
}
</script>

<style scoped>
.Label {
  margin-top: 0px;
}
</style>
